

import { Component } from 'vue-property-decorator';
import ComponentBase from '@/mixins/componentBase';
import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';

@Component({
  name: 'HelpComponent'
})
class HelpComponent extends ComponentBase {
  get pdfLink() {
    const userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;
    const perfilId = userIdentity.perfilId;
    const isEnglish = this.$i18n.locale === 'en';
    let manualFileName = '';

    // Determinar qué manual descargar según el perfilId
    switch (perfilId) {
      case 'CONTR':
        manualFileName = isEnglish
          ? 'PORTAL_CENTRALIZATION_TAS_COUNTERPARTY_EN.pdf'
          : 'PORTAL_CENTRALIZACION_TAS_CONTRAPARTE.pdf';
        break;
      case 'ADM':
        manualFileName = isEnglish
          ? 'PORTAL_CENTRALIZATION_TAS_EN.pdf'
          : 'PORTAL_CENTRALIZACION_TAS.pdf';
        break;
      default:
        manualFileName = isEnglish
          ? 'PORTAL_CENTRALIZATION_TAS_DESK_OPERATOR_EN.pdf'
          : 'PORTAL_CENTRALIZACION_TAS_MESA.pdf';
    }

    return `/manual/${manualFileName}`;
  }
}

export default HelpComponent;
